import React, { useState, useEffect, useCallback } from "react";
import HeaderSales from "../common/HeaderSales";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import axios from "axios";
import * as Constants from "../Constants/index";
import swal from "sweetalert";
import { saveAs } from "file-saver";
import Oval from "../../loader/CircleLoade";
import ResponsivePagination from "react-responsive-pagination";
import Sidebar from "../common/Sidebar";

const redemptionReportColumns = [
    { label: "Redemption ID", index: 0 },
    { label: "Sub Order Item ID", index: 1 },
    { label: "Member ID", index: 2 },
    { label: "Member Name", index: 3 },
    { label: "Member Mobile Number", index: 4 },
    { label: "Firm Name", index: 5 },
    { label: "State", index: 6 },
    { label: "District", index: 7 },
    { label: "City", index: 8 },
    { label: "Work Pincode", index: 9 },
    { label: "Redemption Request Date", index: 10, isDate: true },
    { label: "Order Type", index: 11 },
    { label: "Total Redeemed Points", index: 12 },
    { label: "Total Points", index: 13 },
    { label: "INR Value", index: 14 },
    { label: "Product Name", index: 15 },
    { label: "Product Quantity", index: 16 },
    { label: "Product Points", index: 17 },
    { label: "Product SAP Code", index: 18 },
    { label: "Item Status", index: 19 },
    { label: "Item Delivered Quantity", index: 20 },
    { label: "Item Cancelled Quantity", index: 21 },
    { label: "Item Delivery Date", index: 22, isDate: true },
    { label: "Item Cancel Date", index: 23, isDate: true },
    { label: "Item Remark", index: 24 },
    { label: "Item Transaction ID", index: 25 },
    { label: "UPI ID", index: 26 },
    { label: "Account Number", index: 27 },
    { label: "Account Holder Name", index: 28 },
    { label: "IFSC Code", index: 29 },
    { label: "Bank Name", index: 30 },
    { label: "Status", index: 31 },
    { label: "Remark", index: 32 },
    { label: "Transaction ID", index: 33 },
    { label: "UPI Status", index: 34 },
    { label: "UPI Trans ID", index: 35 },
    { label: "UPI Order ID", index: 36 },
    { label: "Address 1", index: 37 },
    { label: "Address 2", index: 38 },
    { label: "Address 3", index: 39 },
    { label: "Pincode", index: 40 },
    { label: "City", index: 41 },
    { label: "District", index: 42 },
    { label: "State", index: 43 },
    { label: "Pan Number", index: 44, isLink: true },
    { label: "PAN Front URL", index: 45, isLink: true },
    { label: "Cancel Cheque", index: 46, isLink: true },
];

const getCellValue = (value) => {
    if (
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "") ||
        (typeof value === "string" && value.trim().toLowerCase() === "null")
    ) {
        return "N/A";
    }

    return value;
};

const formatDateValue = (value) => {
    const displayValue = getCellValue(value);

    if (displayValue === "N/A") {
        return displayValue;
    }

    const parsedDate = moment(
        displayValue,
        [
            moment.ISO_8601,
            "YYYY-MM-DD",
            "YYYY-MM-DDTHH:mm:ss.SSS",
            "YYYY-MM-DDTHH:mm:ss.SSSZ",
            "YYYY-MM-DDTHH:mm:ssZ",
        ],
        true
    );

    return parsedDate.isValid()
        ? parsedDate.format("DD-MM-YYYY")
        : displayValue;
};

export default function RedemptionReport() {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [results, setResults] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(10);
    const [changeStatus, setStatus] = useState("");
    const [loading, setLoading] = useState(false);
    const [numberFilter, setNumberFilter] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [rotationAngle, setRotationAngle] = useState(0);
    const [imageScale, setImageScale] = useState(1);
    const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
    const defaultFilters = {
        fromDate: null,
        toDate: null,
        changeStatus: "",
        numberFilter: "",
    };

    useEffect(() => {
        fetchList(
            {
                fromDate,
                toDate,
                changeStatus,
                numberFilter,
            },
            currentPage
        );
    }, [currentPage]);

    const fetchList = async (filters, page) => {
        setLoading(true);
        try {
            const activeFilters = filters || {
                fromDate,
                toDate,
                changeStatus,
                numberFilter,
            };
            const pageNumber = page ?? currentPage;
            const start = activeFilters.fromDate
                ? moment(activeFilters.fromDate).format("YYYY-MM-DD 00:00:00")
                : "";
            const end = activeFilters.toDate
                ? moment(activeFilters.toDate).format("YYYY-MM-DD 23:59:59")
                : "";

            const params = new URLSearchParams();
            params.append("sortBy", "createDateTime");
            params.append("sortAsc", "true");
            params.append("limit", limit);
            params.append("page", pageNumber);

            if (activeFilters.changeStatus) params.append("status", activeFilters.changeStatus);
            if (start) params.append("start", start);
            if (end) params.append("end", end);
            if (activeFilters.numberFilter) params.append("mobile", activeFilters.numberFilter);

            const url = `${Constants.baseUrl}reports/redemption/list?${params.toString()}`;

            const res = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Accept-Language": localStorage.getItem("langauge"),
                    appVersion: Constants.av,
                    platform: Constants.pt,
                    company: Constants.company,
                    program: Constants.program,
                }
            });

            if (res.status === 200 || res.status === 201) {
                if (res.data.code === 10001) {
                    setResults(res.data.output?.results || []);
                    setTotalPages(res.data.output?.totalPages || 0);
                } else if (res.data.code === 12002) {
                    setResults([]);
                    setTotalPages(0);
                } else {
                    swal({
                        text: res.data.msg,
                        icon: "error",
                        timer: 2000,
                        buttons: false,
                    });
                    setResults([]);
                }
            }
        } catch (err) {
            console.log(err);
            swal({
                text: "Something went wrong while fetching data",
                icon: "error",
                timer: 2000,
                buttons: false,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = () => {
        const activeFilters = {
            fromDate,
            toDate,
            changeStatus,
            numberFilter,
        };
        if (currentPage === 1) {
            fetchList(activeFilters, 1);
        }
        setCurrentPage(1);
    };

    const download = async () => {
        setLoading(true);
        try {
            const start = fromDate
                ? moment(fromDate).format("YYYY-MM-DD 00:00:00")
                : "";
            const end = toDate
                ? moment(toDate).format("YYYY-MM-DD 23:59:59")
                : "";

            const params = new URLSearchParams();
            if (changeStatus) params.append("status", changeStatus);
            if (start) params.append("start", start);
            if (end) params.append("end", end);
            if (numberFilter) params.append("mobile", numberFilter);

            const url = `${Constants.baseUrl}reports/download/redemptionReport?${params.toString()}`;

            const res = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Accept-Language": localStorage.getItem("langauge"),
                    appVersion: Constants.av,
                    platform: Constants.pt,
                    company: Constants.company,
                    program: Constants.program,
                },
                responseType: "blob",
            });

            if (res.status === 200) {
                saveAs(new Blob([res.data]), "redeemReports.csv");
            }
        } catch (error) {
            swal("Error", "Failed to download report", "error");
        } finally {
            setLoading(false);
        }
    };

    const openImageModal = (imageUrl) => {
        setSelectedImage(imageUrl);
        setRotationAngle(0);
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
        setIsModalOpen(true);
    };

    const closeImageModal = () => {
        setSelectedImage(null);
        setRotationAngle(0);
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
        setIsModalOpen(false);
    };

    const handleReset = () => {
        setFromDate(defaultFilters.fromDate);
        setToDate(defaultFilters.toDate);
        setNumberFilter(defaultFilters.numberFilter);
        setStatus(defaultFilters.changeStatus);
        if (currentPage === 1) {
            fetchList(defaultFilters, 1);
        }
        setCurrentPage(1);
    };

    const rotateLeft = () => {
        setRotationAngle(prevAngle => prevAngle - 90);
    };

    const rotateRight = () => {
        setRotationAngle(prevAngle => prevAngle + 90);
    };

    const zoomIn = () => {
        setImageScale((currentScale) => Math.min(currentScale + 0.25, 3));
    };

    const zoomOut = () => {
        setImageScale((currentScale) => Math.max(currentScale - 0.25, 0.5));
    };

    const resetImagePreview = () => {
        setRotationAngle(0);
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    const moveImage = (x, y) => {
        setImagePosition((currentPosition) => ({
            x: currentPosition.x + x,
            y: currentPosition.y + y,
        }));
    };

    return (
        <>
            {loading && <Oval />}

            {/* --- SIDEBAR LAYOUT WRAPPER START --- */}
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    minHeight: "100vh",
                    backgroundColor: "#f5f7fa",
                }}
            >
                {/* Sidebar Fixed Left */}
                <div style={{ flexShrink: 0 }}>
                    <Sidebar />
                </div>

                {/* Content Area Resizable Right */}
                <div
                    style={{
                        flex: 1,
                        padding: "20px",
                        overflowX: "auto",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div
                        className="all-single-blog rpt"
                        style={{
                            backgroundColor: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            flex: 1,
                            marginTop: "20px"
                        }}
                    >
                        {/* Tabs */}
                        <div className="row">
                            <div className="col-md-12 tab mb-20">
                                <ul className="nav nav-tabs" role="tablist">
                                    <li role="presentation" className="active">
                                        <Link to="#Section1" role="tab" data-toggle="tab">
                                            Redemption Report
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* ================= FILTERS ================= */}
                        <div className="row clearfix mb-15">
                            <div className="col-md-3 col-sm-12 col-xs-12">
                                <div className="form-group has-float-label style-two">
                                    <label>Mobile</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={numberFilter}
                                        onChange={(e) => {
                                            if (/^\d{0,10}$/.test(e.target.value)) {
                                                setNumberFilter(e.target.value);
                                            }
                                        }}
                                        maxLength="10"
                                        placeholder="Enter mobile"
                                    />
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-12 col-xs-12">
                                <div className="form-group has-float-label style-two">
                                    <label>From Date</label>
                                    <DatePicker
                                        selected={fromDate}
                                        onChange={setFromDate}
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control"
                                        maxDate={new Date()}
                                        isClearable
                                        placeholderText="Select start date"
                                    />
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-12 col-xs-12">
                                <div className="form-group has-float-label style-two">
                                    <label>To Date</label>
                                    <DatePicker
                                        selected={toDate}
                                        onChange={setToDate}
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control"
                                        maxDate={new Date()}
                                        isClearable
                                        placeholderText="Select end date"
                                    />
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-12 col-xs-12">
                                <div className="form-group has-float-label style-two">
                                    <label>Status</label>
                                    <select
                                        className="form-control2"
                                        value={changeStatus}
                                        onChange={(e) => setStatus(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        <option value="CANCELLED">CANCELLED</option>
                                        <option value="INPROCESS">In-Process</option>
                                        <option value="DELIVERED">Delivered</option>
                                        <option value="ORDERED">Ordered</option>
                                    </select>
                                </div>
                            </div>

                            <div style={{ display: "flex", gap: "12px", justifyContent: "left", marginTop: "10px" }}>
                                {/* Search */}
                                <button
                                    type="button"
                                    onClick={handleSearch}
                                    style={{
                                        backgroundColor: "#28a745",
                                        color: "#fff",
                                        border: "none",
                                        padding: "5px 18px",
                                        fontSize: "12px",
                                        borderRadius: "3px",
                                        cursor: "pointer",
                                        minWidth: "120px"
                                    }}
                                >
                                    SEARCH
                                </button>

                                {/* Reset */}
                                <button
                                    type="button"
                                    onClick={handleReset}
                                    style={{
                                        backgroundColor: "#6c757d",
                                        color: "#fff",
                                        border: "none",
                                        padding: "5px 18px",
                                        fontSize: "12px",
                                        borderRadius: "3px",
                                        cursor: "pointer",
                                        minWidth: "120px",
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>

                        {/* ================= TABLE ================= */}
                        <div className="row">
                            <div className="col-md-12">
                                <div className="carrd1" style={{ marginTop: "20px" }}>
                                    <div
                                        className="card-header card-header-warning"
                                        style={{
                                            backgroundColor: "#28a745",
                                            color: "white",
                                            padding: "10px 15px",
                                            borderRadius: "4px 4px 0 0",
                                        }}
                                    >
                                        <h4
                                            className="card-title"
                                            style={{
                                                margin: 0,
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <span>Redemption Report</span>
                                            {results.length > 0 && (
                                                <Link
                                                    to="#"
                                                    className="pull-right btn btn-sm btn-light"
                                                    style={{ color: "#28a745", fontWeight: "bold" }}
                                                    onClick={download}
                                                >
                                                    <i className="fa fa-file-excel-o"></i> Export
                                                </Link>
                                            )}
                                        </h4>
                                    </div>

                                    <div
                                        className="card-body table-responsive"
                                        style={{ border: "1px solid #ddd", borderTop: "none" }}
                                    >
                                        <table
                                            className="table table-striped mb_01"
                                            id="table-to-xls"
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        style={{
                                                            borderRight: "2px solid #dee2e6",
                                                            backgroundColor: "#f8f9fa",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                            minWidth: "60px"
                                                        }}
                                                    >
                                                        S.No
                                                    </th>
                                                    {redemptionReportColumns.map((column) => (
                                                        <th
                                                            key={`${column.index}-${column.label}`}
                                                            style={{
                                                                borderRight: column.index < redemptionReportColumns.length - 1 ? "1px solid #dee2e6" : "none",
                                                                whiteSpace: "nowrap"
                                                            }}
                                                        >
                                                            {column.label}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {results.length > 0 ? (
                                                    results.map((item, index) => {
                                                        // Internal helper to render the "View" button for URLs
                                                        const renderLink = (value) => {
                                                            const displayValue = getCellValue(value);

                                                            if (
                                                                typeof displayValue === "string" &&
                                                                displayValue.includes("http")
                                                            ) {
                                                                return (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => openImageModal(displayValue)}
                                                                        style={{
                                                                            color: "#0d6efd",
                                                                            textDecoration: "underline",
                                                                            background: "transparent",
                                                                            border: "none",
                                                                            padding: 0,
                                                                            cursor: "pointer",
                                                                            font: "inherit",
                                                                        }}
                                                                    >
                                                                        View
                                                                    </button>
                                                                );
                                                            }
                                                            return displayValue;
                                                        };

                                                        return (
                                                            <tr key={index}>
                                                                <td
                                                                    style={{
                                                                        borderRight: "2px solid #dee2e6",
                                                                        textAlign: "center",
                                                                        fontWeight: "500",
                                                                        backgroundColor: "#f8f9fa"
                                                                    }}
                                                                >
                                                                    {(currentPage - 1) * limit + index + 1}
                                                                </td>
                                                                {redemptionReportColumns.map((column) => (
                                                                    <td
                                                                        key={`${column.index}-${column.label}`}
                                                                        style={{
                                                                            borderRight: column.index < redemptionReportColumns.length - 1 ? "1px solid #dee2e6" : "none"
                                                                        }}
                                                                    >
                                                                        {column.isLink
                                                                            ? renderLink(item[column.index])
                                                                            : column.isDate
                                                                                ? formatDateValue(item[column.index])
                                                                                : getCellValue(item[column.index])}
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan={redemptionReportColumns.length + 1}
                                                            style={{
                                                                textAlign: "center",
                                                                fontSize: "16px",
                                                                padding: "20px",
                                                            }}
                                                        >
                                                            No record found!
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <div
                                            style={{
                                                marginTop: "15px",
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            {totalPages > 1 && (
                                                <ResponsivePagination
                                                    current={currentPage}
                                                    total={totalPages}
                                                    onPageChange={setCurrentPage}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
            {/* --- SIDEBAR LAYOUT WRAPPER END --- */}

            {isModalOpen && selectedImage && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(0, 0, 0, 0.85)",
                        padding: "30px",
                    }}
                    onClick={closeImageModal}
                >
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "1200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            padding: "20px",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button - Top Right with more spacing */}
                        <button
                            type="button"
                            onClick={closeImageModal}
                            style={{
                                position: "absolute",
                                top: "20px",
                                right: "20px",
                                zIndex: 10000,
                                width: "40px",
                                height: "40px",
                                border: "none",
                                borderRadius: "9999px",
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                                color: "#fff",
                                fontSize: "22px",
                                lineHeight: 1,
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.3s ease",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#dc3545";
                                e.currentTarget.style.transform = "scale(1.1)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.75)";
                                e.currentTarget.style.transform = "scale(1)";
                            }}
                            aria-label="Close image preview"
                        >
                            ✕
                        </button>

                        {/* Image controls */}
                        <div
                            style={{
                                position: "absolute",
                                top: "75px",
                                right: "20px",
                                zIndex: 10000,
                                display: "flex",
                                flexDirection: "column",
                                flexWrap: "nowrap",
                                gap: "8px",
                                alignItems: "center",
                                overflowY: "auto",
                                maxHeight: "calc(100vh - 120px)",
                                backgroundColor: "rgba(0, 0, 0, 0.6)",
                                padding: "10px",
                                borderRadius: "10px",
                                backdropFilter: "blur(10px)",
                                border: "1px solid rgba(255,255,255,0.15)",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
                            }}
                        >
                            <button
                                type="button"
                                onClick={zoomIn}
                                style={{
                                    width: "36px",
                                    height: "36px",
                                    flex: "0 0 36px",
                                    border: "1px solid rgba(255,255,255,0.2)",
                                    borderRadius: "6px",
                                    backgroundColor: "rgba(255,255,255,0.05)",
                                    color: "#fff",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                title="Zoom in"
                                aria-label="Zoom in"
                            >
                                +
                            </button>

                            <button
                                type="button"
                                onClick={zoomOut}
                                style={{
                                    width: "36px",
                                    height: "36px",
                                    flex: "0 0 36px",
                                    border: "1px solid rgba(255,255,255,0.2)",
                                    borderRadius: "6px",
                                    backgroundColor: "rgba(255,255,255,0.05)",
                                    color: "#fff",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                title="Zoom out"
                                aria-label="Zoom out"
                            >
                                -
                            </button>

                            <button
                                type="button"
                                onClick={() => moveImage(0, -30)}
                                style={{ width: "36px", height: "36px", flex: "0 0 36px", border: "1px solid rgba(255,255,255,0.2)", borderRadius: "6px", backgroundColor: "rgba(255,255,255,0.05)", color: "#fff", fontSize: "18px", cursor: "pointer" }}
                                title="Move up"
                                aria-label="Move image up"
                            >
                                &uarr;
                            </button>
                            <button
                                type="button"
                                onClick={() => moveImage(-30, 0)}
                                style={{ width: "36px", height: "36px", flex: "0 0 36px", border: "1px solid rgba(255,255,255,0.2)", borderRadius: "6px", backgroundColor: "rgba(255,255,255,0.05)", color: "#fff", fontSize: "18px", cursor: "pointer" }}
                                title="Move left"
                                aria-label="Move image left"
                            >
                                &larr;
                            </button>
                            <button
                                type="button"
                                onClick={() => moveImage(30, 0)}
                                style={{ width: "36px", height: "36px", flex: "0 0 36px", border: "1px solid rgba(255,255,255,0.2)", borderRadius: "6px", backgroundColor: "rgba(255,255,255,0.05)", color: "#fff", fontSize: "18px", cursor: "pointer" }}
                                title="Move right"
                                aria-label="Move image right"
                            >
                                &rarr;
                            </button>
                            <button
                                type="button"
                                onClick={() => moveImage(0, 30)}
                                style={{ width: "36px", height: "36px", flex: "0 0 36px", border: "1px solid rgba(255,255,255,0.2)", borderRadius: "6px", backgroundColor: "rgba(255,255,255,0.05)", color: "#fff", fontSize: "18px", cursor: "pointer" }}
                                title="Move down"
                                aria-label="Move image down"
                            >
                                &darr;
                            </button>

                            <button
                                type="button"
                                onClick={rotateLeft}
                                style={{
                                    width: "36px",
                                    height: "36px",
                                    flex: "0 0 36px",
                                    border: "1px solid rgba(255,255,255,0.2)",
                                    borderRadius: "6px",
                                    backgroundColor: "rgba(255,255,255,0.05)",
                                    color: "#fff",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.2s ease",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.15)";
                                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.5)";
                                    e.currentTarget.style.transform = "scale(1.05)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)";
                                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)";
                                    e.currentTarget.style.transform = "scale(1)";
                                }}
                                title="Rotate Left (90°)"
                            >
                                ↺
                            </button>

                            <button
                                type="button"
                                onClick={resetImagePreview}
                                style={{
                                    width: "36px",
                                    height: "36px",
                                    flex: "0 0 36px",
                                    border: "1px solid rgba(255,255,255,0.2)",
                                    borderRadius: "6px",
                                    backgroundColor: "rgba(255,255,255,0.05)",
                                    color: "#fff",
                                    fontSize: "10px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.2s ease",
                                    fontWeight: "bold",
                                    letterSpacing: "0.3px",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.15)";
                                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.5)";
                                    e.currentTarget.style.transform = "scale(1.05)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)";
                                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)";
                                    e.currentTarget.style.transform = "scale(1)";
                                }}
                                title="Reset zoom and rotation"
                            >
                                Reset
                            </button>

                            <button
                                type="button"
                                onClick={rotateRight}
                                style={{
                                    width: "36px",
                                    height: "36px",
                                    flex: "0 0 36px",
                                    border: "1px solid rgba(255,255,255,0.2)",
                                    borderRadius: "6px",
                                    backgroundColor: "rgba(255,255,255,0.05)",
                                    color: "#fff",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.2s ease",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.15)";
                                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.5)";
                                    e.currentTarget.style.transform = "scale(1.05)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)";
                                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)";
                                    e.currentTarget.style.transform = "scale(1)";
                                }}
                                title="Rotate Right (90°)"
                            >
                                ↻
                            </button>

                        </div>

                        <img
                            src={selectedImage}
                            alt="Redemption document preview"
                            style={{
                                maxWidth: "95%",
                                maxHeight: "80vh",
                                objectFit: "contain",
                                borderRadius: "10px",
                                backgroundColor: "#fff",
                                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.35)",
                                transform: `translate(${imagePosition.x}px, ${imagePosition.y}px) rotate(${rotationAngle}deg) scale(${imageScale})`,
                                transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                margin: "20px",
                            }}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
